import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useContext, useState, useEffect } from "react";
import MainContext from "../../context/main/mainContext";
import StripeAddPaymentModal from "./StripeAddPaymentModal";
import TeamSubscriptionForm from "./TeamSubscriptionForm";
import TeamSubscriptionUpdatesForm from "./TeamSubscriptionUpdatesForm";
import InternalDemoTeamForm from "./InternalDemoTeamForm";

const VIEWS = {
  FULL: "full",
  UPDATES: "updates",
  LEGACY: "legacy",
};

export default function TeamSubscriptionWrapper() {
  const mainContext = useContext(MainContext);
  const { isProd, stripe_customer, getCustomerPaymentMethods } = mainContext || {};
  const [activeView, setActiveView] = useState(VIEWS.LEGACY);

  const [stripePromise, setStripePromise] = useState(null);
  const [openStripePaymentModal, setOpenStripePaymentModal] = useState(false);

  useEffect(() => {
    loadStripe(
      isProd
        ? "pk_live_51ISRsnJqkGKmOFO6LLM2GcznWFLHS40RpqGm5N58il5MgKyT3XbfMw0r3jgbpGRcyq24rtr3YrK8Bbd4DaJTO7Pm00dmW3rNlq"
        : "pk_test_51ISRsnJqkGKmOFO6YXwekNU7nltG5qZLswJWgSyQnC78FFt8d5ZxveEdy9bqmVbVPMkxAjeqdc17Wy7sCxYlAPnK00eb2dGR0l",
    ).then((res) => {
      setStripePromise(res);
    });
  }, []);

  useEffect(() => {
    if (stripe_customer?.id) {
      getCustomerPaymentMethods(
        {
          stripeCustomerId: stripe_customer.id,
        },
        (err) => {
          if (err) {
            alert(err);
          }
        },
      );
    }
  }, [stripe_customer]);

  const handleOpenStripePaymentModal = (open) => {
    setOpenStripePaymentModal(() => open);
  };

  const stripeOptions = {
    mode: "setup",
    currency: "usd",
    paymentMethodTypes: ["card"],
    disableLink: true,
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      {stripePromise && (
        <Elements stripe={stripePromise} options={stripeOptions}>
          <StripeAddPaymentModal
            stripe={stripePromise}
            stripeCustomerId={stripe_customer?.id}
            open={openStripePaymentModal}
            closeModal={() => setOpenStripePaymentModal(false)}
          />
        </Elements>
      )}

      <div className="">
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
          <aside className="col-span-1">
            <div className="sticky top-8 space-y-3">
              <h3 className="text-sm font-medium text-gray-900 mb-2">Views</h3>
              <button
                type="button"
                onClick={() => setActiveView(VIEWS.LEGACY)}
                className={`flex flex-col items-start w-full text-left px-4 py-2 rounded-md border transition ${activeView === VIEWS.LEGACY
                    ? "bg-white border-gray-300 shadow-sm"
                    : "bg-transparent border-transparent hover:bg-white hover:border-gray-200"
                  }`}
              >
                <div className="text-sm font-semibold text-gray-900">Legacy</div>
                <div className="text-xs text-gray-500">Use legacy pricing</div>
              </button>
              <button
                type="button"
                onClick={() => setActiveView(VIEWS.FULL)}
                className={`flex flex-col items-start w-full text-left px-4 py-2 rounded-md border transition ${activeView === VIEWS.FULL
                    ? "bg-white border-gray-300 shadow-sm"
                    : "bg-transparent border-transparent hover:bg-white hover:border-gray-200"
                  }`}
              >
                <div className="text-sm font-semibold text-gray-900">Full subscription</div>
                <div className="text-xs text-gray-500">
                  Company, billing, seats, enrichment, CSM
                </div>
              </button>

              {!!stripe_customer?.subscriptions?.data?.length && <button
                type="button"
                onClick={() => setActiveView(VIEWS.UPDATES)}
                className={`flex flex-col items-start w-full text-left px-4 py-2 rounded-md border transition ${activeView === VIEWS.UPDATES
                    ? "bg-white border-gray-300 shadow-sm"
                    : "bg-transparent border-transparent hover:bg-white hover:border-gray-200"
                  }`}
              >
                <div className="text-sm font-semibold text-gray-900">Subscription Item Updates</div>
                <div className="text-xs text-gray-500">
                  Use for prorations and subscription item changes
                </div>
              </button>}
            </div>
          </aside>

          {/* Content area */}
          <main className="col-span-1 lg:col-span-5">
            {(() => {
              if (activeView === VIEWS.FULL) {
                return (
                  <div>
                    {/* Full form component */}
                    <TeamSubscriptionForm onOpenStripePaymentModal={handleOpenStripePaymentModal} />
                  </div>
                );
              }
              if (activeView === VIEWS.UPDATES) {
                return (
                  <div>
                    {/* Minimal/updates-only component */}
                    <TeamSubscriptionUpdatesForm
                      onOpenStripePaymentModal={handleOpenStripePaymentModal}
                    />
                  </div>
                );
              }
              return (
                <div>
                  <InternalDemoTeamForm />
                </div>
              );
            })()}
          </main>
        </div>
      </div>
    </div>
  );
}
